import { Stack, StackProps, Typography, styled } from '@mui/material';

export type ContentIslandHeaderOwnProps = {
  title?: React.ReactNode;
  actions?: React.ReactNode;
};

export type ContentIslandHeaderProps = StackProps<'div', ContentIslandHeaderOwnProps>;

const StyledStack = styled(Stack, {
  name: 'ContentIslandHeader',
  slot: 'root',
})(({ theme }) => ({
  padding: theme.spacing(3, 4),
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export function ContentIslandHeader({ title, actions, ...props }: ContentIslandHeaderProps) {
  return (
    <StyledStack direction="row" {...props}>
      <Typography
        variant="body1"
        sx={{
          color: 'text.secondary',
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>
      {actions}
    </StyledStack>
  );
}
